<div [ngSwitch]="getType(document)">

  <img *ngSwitchCase="'img'" class="displayImg" [src]="document">
  <p *ngSwitchCase="'file'">file not type of img</p>
  <p *ngSwitchDefault>file Not Found</p>
</div>
